import { createFileRoute } from "@tanstack/react-router";
import { HomeScreen } from "@ui/screens/HomeScreen";

export const Route = createFileRoute("/home")({
  component: HomeScreen,
});
